import { ellipsisLayout, theyFit } from './ellipsisLayout';
import { BreadcrumbsLayout, InternalBreadcrumbsProps } from './types';
import { mesureSegment } from './DOMHelpers';
import { makeSegment, toHighlightedTextConfig, toSegments } from './segments';

export const breadcrumbsLayout = (
  props: InternalBreadcrumbsProps,
  availableWidth: number
): BreadcrumbsLayout => {
  const { breadcrumbs, ellipsis, leadingIcon, dividerIcon, textStyles } = props;

  const segments = toSegments(breadcrumbs, leadingIcon, dividerIcon);
  const segmentsWithSizes = segments.map(segment =>
    mesureSegment(segment, textStyles)
  );

  if (theyFit(segmentsWithSizes, availableWidth)) {
    return { breadcrumbs: segments };
  }

  if (segments.length <= 2) {
    return { breadcrumbs: segments, popoverContent: segments };
  }

  const ellipsisWithSizes = mesureSegment(
    makeSegment(toHighlightedTextConfig(ellipsis), dividerIcon),
    textStyles
  );
  const segmentsWithEllipsis = ellipsisLayout(
    segmentsWithSizes,
    availableWidth,
    ellipsisWithSizes
  );
  return {
    breadcrumbs: segmentsWithEllipsis,
    popoverContent: segments,
  };
};
